'use client';

import { useState } from 'react';
import { useWorkflowStore } from '../../../stores/workflowStore';
import { FileUploadWidget } from './FileUploadWidget';

interface LoadExcelConfigProps {
  nodeId: string;
  config: { fileName?: string; rowCount?: number; table?: string };
}

export function LoadExcelConfig({ nodeId, config }: LoadExcelConfigProps) {
  const { updateNodeConfig } = useWorkflowStore();
  const [table, setTable] = useState(config.table || '');

  const saveTable = (val: string) => {
    updateNodeConfig(nodeId, {
      type: 'load_excel',
      params: { fileName: config.fileName, rowCount: config.rowCount, table: val },
    });
  };

  return (
    <div className="space-y-5">
      {/* File upload area */}
      <FileUploadWidget nodeId={nodeId} accept="excel" />

      {/* Table alias */}
      <div className="space-y-1.5">
        <label className="text-xs font-medium text-zinc-500">表别名（可选）</label>
        <input
          type="text"
          placeholder="例如：销售数据"
          value={table}
          onChange={(e) => { setTable(e.target.value); saveTable(e.target.value); }}
          className="w-full text-sm bg-white border border-zinc-200 rounded-lg px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 placeholder:text-zinc-400"
        />
        <p className="text-[10px] text-zinc-400">在后续节点中用于引用该数据源</p>
      </div>
    </div>
  );
}
